'use strict';
import 'spritespin';

class gallery_360 {
    spriteSpinData

    constructor(elementId) {
        if (!document.getElementById('mySpriteSpinM-' + elementId)
            || !document.getElementById('mySpriteSpinD-' + elementId)) {
            return
        }

        if (Modernizr.webp) {
            this.spriteSpinData = 'webp-src'
        } else {
            this.spriteSpinData = 'src'
        }

        let mySpriteSpinId
        if ($(window).width() <= '768') {
            mySpriteSpinId = '#mySpriteSpinM-' + elementId;
        } else {
            mySpriteSpinId = '#mySpriteSpinD-' + elementId;
        }
        this.bootSpriteSpin(mySpriteSpinId, {
            source: $(mySpriteSpinId).data(this.spriteSpinData),
            sense: -1,
            sizeMode: 'fit',
            responsive: true,
            plugins: ['progress', '360', 'drag']
        })

        $('#view360-' + elementId).click(function () {
            $('#mySpriteSpinD-' + elementId).addClass('active')
        })

        $('.gallery-thumbs_item__link').click(function () {
            $('#mySpriteSpinD-' + elementId).removeClass('active')
        })

        /**
         * Попап с галереей 360
         */
        $('#g360-' + elementId).popup({
            scrolllock: true
        })
    }

    bootSpriteSpin(selector, options) {
        if ('IntersectionObserver' in window) {
            // Если браузер поддерживает IntersectionObserver, используем его для отложенной инициализации
            // Если браузер его не поддерживает, то 360 галерея не будет работать
            let observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    // Для каждого элемента проверяем, пересекается ли он с областью видимости
                    if (entry.isIntersecting) {
                        // Если элемент пересекается, прекращаем его наблюдение
                        observer.unobserve(entry.target);
                        // Инициализируем SpriteSpin для целевого элемента
                        $(entry.target).spritespin(options);
                    }
                });
            });
            // Начинаем наблюдение за элементом, выбранным селектором
            observer.observe($(selector)[0]);
        }
    }
}

export default gallery_360;